<template>
  <div class="">
    <!-- 顶部区 -->
    <div class='top'>
      <Top></Top>
      <div class='line'></div>
      <div class='top_content'>
        <div class='top_title'>
          欢迎合作联系
        </div>
      </div>
    </div>

    <!-- 业务合作咨询 -->
    <div class='brief container'>
      <div class='title'>业务合作咨询</div>
      <!--  class="vue_flex" -->
	  <div>
        <div class="title_content">
          <img class="img_box" src='../assets/youxiang.png'/>
          <span style="line-height: 120px;">邮箱：c@feedying.com</span>
        </div>
        <!-- <div class="title_content">
          <img class="img_box" src='../assets/shouji.png'/>
          <span style="line-height: 120px;">手机：18879750291</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/layout_web/top';
export default {
  components: {
		Top
	},
}
</script>

<style lang="scss" scoped>

// 顶部区
.top{
  width: 100%;
  height:422px;
  background-image: url(../assets/banner2.jpg);
  background-repeat: no-repeat;
  background-size:cover;// 全覆盖
  background-position: center; //指定元素背景图片的位置
  // background-size: 100% 100%;
  .line{
    position: absolute;
    top: 72px;
    width: 100%;
    // margin: auto;
    height:1px; 
    background-color: rgba(77, 136, 255, 0.35);
  }
  .top_content{
    position: relative;
    top: -380px;
    left: 50px;
    // position: absolute;
    // top: 62px;
    // left: 25%;
    font-family: 'MicrosoftYaHei';
    // padding:80px 40px;
    // width:60vw;
    width: 1000px;
    margin:auto;
    color:#FFFFFF;
    display:flex;
    height:350px;
    flex-direction: column;// 主轴为垂直方向，起点在上沿
    justify-content:center;
    // align-items: center;
    // box-sizing:border-box;// 规定大小 不会因为边距改变
    .top_title{
      font-family: 'MicrosoftYaHei';
      font-size:28px;
      margin-top:10px;
    }
  }
}

// 标题
.title{
  width: 220px;
  font-size:32px;
  margin: 15px 0 50px 0;
  text-align: center;
  
  display: inline-block;
  background: linear-gradient(to bottom, transparent 50%, #D8E3FF 50%);
}

.title_content{
  margin: auto;
  font-size:18px;
  width: 430px;
  height: 120px;
  padding-left: -20px;
  box-sizing: border-box;
  background-color: #F2F2F2;
  .img_box{
    width: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }
}

// 公司简介
.brief{
  margin:85px auto 95px;
  text-align: center;
}

// // 小于1500px
// @media screen and (max-width:1500px) {
//   .top_content{
//     width:60vw;
//   }
// }
// // 大于1500px 小于2000px
// @media screen and (min-width:1500px) and (max-width:2000px) {
//   .top_content{
//     width:48vw;
//   }
// }
// @media screen and (min-width:2000px){
//   .top_content{
//     width:40vw;
//   }
// }
</style>